<template>
    <div class="footer-container">
        <div class="mail-block" id="contact">
            <div class="links-container">
                <div class="links">
                    <a href="https://t.me/zeroliquid_manager">@zeroliquid_manager</a>
                </div>
                <svg xmlns="http://www.w3.org/2000/svg" width="44" height="44" viewBox="0 0 44 44" fill="none"> <path fill-rule="evenodd" clip-rule="evenodd" d="M19.4167 0.162533C0.653955 2.42865 -6.78618 26.0806 7.37573 38.4401C21.5481 50.8087 43.5622 41.2424 43.9939 22.5276C44.3041 9.08668 32.7301 -1.4455 19.4167 0.162533ZM27.1622 18.0099C29.5526 16.329 31.4956 14.9139 31.4803 14.8652C31.4619 14.8071 28.2159 14.7689 22.0365 14.754C12.8591 14.732 12.2293 14.7475 12.5817 14.9858C12.7242 15.0822 21.2043 21.0541 21.4985 21.2653C21.8509 21.5182 22.1807 21.5182 22.5362 21.2653C22.6902 21.1557 24.7719 19.6907 27.1622 18.0099ZM20.5302 22.9333C20.2493 22.7248 18.151 21.231 15.8674 19.6136C13.5838 17.9962 11.657 16.6506 11.5857 16.6233C11.4726 16.58 11.456 17.3435 11.456 22.5485V28.5233L11.6603 28.909C11.8 29.1727 11.987 29.3593 12.2511 29.4987L12.6375 29.7027H22.0113H31.3851L31.781 29.5034C32.0703 29.3578 32.2308 29.1976 32.3766 28.9089L32.5763 28.5136V22.5436C32.5763 17.8038 32.5534 16.5824 32.4654 16.6164C32.4044 16.6399 30.3698 18.0692 27.9441 19.7927C25.5185 21.5161 23.4095 23.0135 23.2575 23.1203C22.4938 23.6572 21.4051 23.5826 20.5302 22.9333Z" fill="white"/> </svg>
            </div>
            <div class="additional">
                <a href="#" class="privacy">{{ $t("footer.privacy") }}</a>
            </div>
        </div>
        <div class="divider"></div>
        <div class="contacts-block">
            <div class="links-container">
                <div class="links">
                    <a href="#">Store (Coming soon...)</a>
                </div>
                <svg xmlns="http://www.w3.org/2000/svg" width="44" height="44" viewBox="0 0 44 44" fill="none"> <path fill-rule="evenodd" clip-rule="evenodd" d="M22 44C34.1503 44 44 34.1503 44 22C44 9.84974 34.1503 0 22 0C9.84974 0 0 9.84974 0 22C0 34.1503 9.84974 44 22 44ZM30.1553 24.8606L22.6406 32.7252C22.2905 33.0916 21.7264 33.0916 21.3762 32.7252L13.7983 24.7945C12.195 23.1436 11.6038 20.6815 12.2686 18.4224C12.9337 16.1618 14.7437 14.4874 16.9521 14.0896C18.8021 13.7564 20.6693 14.3663 22.0122 15.6901C23.3569 14.3792 25.2184 13.7796 27.0606 14.1157C29.261 14.5173 31.0636 16.1864 31.7292 18.4386C32.3949 20.6909 31.8116 23.1474 30.2186 24.8008C30.1982 24.822 30.177 24.8419 30.1553 24.8606Z" fill="white"/> </svg>
            </div>
            <div class="additional copyright">
                {{ $t("footer.copyright") }}
            </div>
        </div>
    </div>
  </template>
  
  <script>
  export default {
    name: "FooterBlock",
  };
  </script>
  
  <style scoped>
    .footer-container {
        margin-bottom: 32px;
        position: relative;
        height: 30vh;
        display: flex;
        justify-content: space-between;
        align-items: start;
        gap: 32px;
    }

    .links-container {
        display: flex;
        justify-content: space-between;
        align-items: center;
    }

    .links {
        display: flex;
        flex-direction: column;
    }

    .mail-block, .contacts-block {
        min-height: 100%;
        width: 100%;
        box-sizing: border-box;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
    }

    .divider {
        height: 100%;
        width: 1px;
        background: #ffffff21;
    }

    a {
        text-decoration: none;
        color: #FFF;
        transition: all 0.25s;
        font-size: clamp(10px, 0.83vw, 16px);
    }

    a:hover {
        opacity: 0.5;
        transition: all 0.25s;
    }

    .additional {
        opacity: 0.5;
        z-index: 100001;
        font-size: clamp(10px, 0.83vw, 16px);
    }

    .additional:hover {
        opacity: 0.2;
    }

    .additional.copyright:hover {
        opacity: 0.5;
    }

    @media screen and (max-width: 768px) {
        .footer-container {
            flex-direction: column;
        }

        .mail-block, .contacts-block {
            min-height: 30%;
        }
    }
  </style>
  
